// extracted by mini-css-extract-plugin
export default {"btn":"index_btn__aPDbl","text":"index_text__FPqKo","error":"index_error__AjS69","addIcon":"index_addIcon__NsCTY"};